export default __webpack_public_path__ + "static/media/instagram.f2e70a8a.svg";